import * as React from 'react';
import { render } from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Route, Switch, Redirect } from 'react-router';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap';
import 'moment/locale/en-gb';
import 'react-datetime/css/react-datetime.css';
import './main.css';
import TimeCalculator from './Calculator/TimeCalculator';
import Timer from './Timer/Timer';
import Navbar from './Navbar';
import { Footer } from './Footer';
import TimerOptions from './Timer/TimerOptions';
import Doomsday from './Doomsday/Doomsday';

class App extends React.Component {

  public render() {
    return (
      <BrowserRouter>
        <div className="container h-100">
          <Navbar />
          <div className="d-flex flex-column navbarmargin h-100">
            <Switch>
              <Route path="/calculator" component={TimeCalculator} />
              <Route path="/doomsday" component={Doomsday} />
              <Route exact={true} path="/timer" component={TimerOptions} />
              <Route exact={true} path="/timer/:myTimerCode" component={Timer} />
              <Route exact={true} path="/timer/remote/:timerCode" component={Timer} />
              <Route>
                <Redirect to="/calculator" />
              </Route>
            </Switch>
            <Footer />
          </div>
        </div>
      </BrowserRouter>
    )
  }
}

render(<App />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.tsx